import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    imports: [CommonModule],
    selector: 'app-info-popup',
    templateUrl: './info-popup.component.html',
})
export class InfoPopupComponent {
    @Input() title = 'Information';
    @Input() message = 'Are you sure you want to proceed?';
    @Input() confirmText = 'Close';

    show = false;

    open() {
        this.show = true;
    }

    close() {
        this.show = false;
    }
}
